import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/jesse.png'


const _withScopeId = n => (_pushScopeId("data-v-295f0845"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "donate" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Donate", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://8333.mobi/lemec",
      target: "_blank"
    }, "https://8333.mobi/lemec")
  ]),
  /*#__PURE__*/_createElementVNode("h4", null, "Lightning Network URL"),
  /*#__PURE__*/_createElementVNode("img", {
    alt: "LNURL QR Code",
    src: _imports_0,
    class: "center-fit"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}